// Issues stats bar — 4 metric cards
import { Card, CardContent } from '@/components/ui/card'
import { FileText, Clock, CheckCircle, AlertCircle } from 'lucide-react'

interface IssueStats {
  total: number
  open: number
  in_progress: number
  resolved: number
}

interface IssuesStatsBarProps {
  stats: IssueStats
  isLoading: boolean
}

function StatCard({ label, value, icon, loading }: {
  label: string; value: number; icon: React.ReactNode; loading: boolean
}) {
  return (
    <Card className="border-kaycoo-teal-light bg-kaycoo-white">
      <CardContent className="flex items-center justify-between px-4 py-3">
        <div>
          <p className="text-xs text-kaycoo-charcoal-2">{label}</p>
          <p className="text-xl font-bold text-kaycoo-teal-dark">{loading ? '...' : value}</p>
        </div>
        {icon}
      </CardContent>
    </Card>
  )
}

export function IssuesStatsBar({ stats, isLoading }: IssuesStatsBarProps): JSX.Element {
  return (
    <div className="grid gap-4 md:grid-cols-4">
      <StatCard label="Total" value={stats.total} icon={<FileText className="h-4 w-4 text-kaycoo-charcoal-2" />} loading={isLoading} />
      <StatCard label="Open" value={stats.open} icon={<AlertCircle className="h-4 w-4 text-kaycoo-burgundy" />} loading={isLoading} />
      <StatCard label="In Progress" value={stats.in_progress} icon={<Clock className="h-4 w-4 text-amber-600" />} loading={isLoading} />
      <StatCard label="Resolved" value={stats.resolved} icon={<CheckCircle className="h-4 w-4 text-kaycoo-teal" />} loading={isLoading} />
    </div>
  )
}
